import { Validators } from "@angular/forms";
import { BasespaceFormControl, BasespaceFormProperties } from "../bs-app-launch-form-control";
import { BsAppLaunchTextInputControlComponent } from "./bs-app-launch-text-input-control.component";

export interface TextBoxFormControlProperties extends BasespaceFormProperties<BsAppLaunchTextInputControlComponent> {
    minLength: string;
    maxLength: string;
}

// Reference docs: https://dagobah-developer.cloud-test.illumina.com/docs/content/documentation/apptools/formbuilder-overview#Textbox
// Reference class: src/Cloud.FormBuilder/Models/TextBox.cs
export class TextBoxFormControl extends BasespaceFormControl<BsAppLaunchTextInputControlComponent> implements TextBoxFormControlProperties {
    minLength: string;
    maxLength: string;

    constructor(
        data: TextBoxFormControlProperties
    ) {
        const { 
            id, 
            componentReference, 
            label, 
            minLength, 
            maxLength, 
            size, 
            helpText, 
            value, 
            required, 
            requiredMessage, 
            tabularFieldSetStyling,
            formControlType
        } = data;

        super({ 
            id, 
            componentReference, 
            label, 
            helpText, 
            size,
            value, 
            required, 
            requiredMessage, 
            tabularFieldSetStyling,
            formControlType
        });

        this.minLength = minLength ? minLength.toString() : '0';
        this.maxLength = maxLength ? maxLength.toString() : '100';

        if(required) {
            this.setValidators(Validators.required);
        }
    
        this.setValue(value || '');
    }
    
}